import type { CustomOptionGroup } from "../../api/products";

const defaults = { length: true, width: true, height: true, flatLength: true, flatWidth: true };
const record = (value: unknown): value is Record<string, unknown> => !!value && typeof value === "object" && !Array.isArray(value);
export const supportsDimensions = (group: CustomOptionGroup) => group.code === "FINISHED_SIZE" && group.inputType === "TEXT";
export function dimensionFields(config: unknown) {
  const fields = record(config) && record(config.dimensionFields) ? config.dimensionFields : {};
  return Object.fromEntries(Object.entries(defaults).map(([key, fallback]) => [key, typeof fields[key] === "boolean" ? fields[key] : fallback])) as typeof defaults;
}
export function dimensionConfig(config: unknown, mode: "plane" | "solid", expanded: boolean) {
  if (config != null && !record(config)) throw new Error("旧尺寸配置格式异常，请先核对原配置");
  const original = record(config) ? config : {};
  return { ...original, dimensionFields: { ...(record(original.dimensionFields) ? original.dimensionFields : {}),
    length: true, width: true, height: mode === "solid", flatLength: mode === "solid" && expanded, flatWidth: mode === "solid" && expanded } };
}
